import { Swiper as SwiperCore, Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';

import './Swiper.scss';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

export { Swiper } from 'swiper/react';
